import { render, staticRenderFns } from "./LoadingChart.vue?vue&type=template&id=78c3ecf8&"
import script from "./LoadingChart.vue?vue&type=script&lang=js&"
export * from "./LoadingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c3ecf8')) {
      api.createRecord('78c3ecf8', component.options)
    } else {
      api.reload('78c3ecf8', component.options)
    }
    module.hot.accept("./LoadingChart.vue?vue&type=template&id=78c3ecf8&", function () {
      api.rerender('78c3ecf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Activity/InsectCountLineChartsButton/LoadingChart.vue"
export default component.exports